import { Navigate, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/app/results/")({
  component: () => <Navigate to="/app/results/daily" />,
})
